import { combineReducers } from 'redux';
import { translationsReducer } from './translations/translations-reducer';
import { baseParamsReducer } from './base-params/base-params-reducer';
import { experimentsReducer } from './experiments/experiments-reducer';
import { membersReducer } from './members/members-reducer';
import { commentsReducer } from './comments/comments-reducer';
import { promisifiedActionsResultsReducer } from './promisified-actions/promisified-actions-reducer';
import { maNavigationReducer } from './ma-navigation/ma-navigation-reducer';
export const rootReducer = combineReducers({
    translations: translationsReducer,
    baseParams: baseParamsReducer,
    experiments: experimentsReducer,
    members: membersReducer,
    comments: commentsReducer,
    promisifiedActionsResults: promisifiedActionsResultsReducer,
    maNavigation: maNavigationReducer,
});
//# sourceMappingURL=root-reducer.js.map